import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboBox";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextInput";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { FormLayout } from "@careinfo/layout";
import NumberField from "../Reusable/NumberField";
import LocationComboboxInput from "../Reusable/LocationCombobox/LocationCombobox";

const Form = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
  fields,
  isEdit,
  watch,
  isSuperUser,
  isActive = true,
  remove,
  append,
}: any) => {
  return (
    <>
      <div className={tw`mx-4`}>
        <div className={tw`grid grid-cols-2 gap-x-4`}>
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("from_branch", {
              required: "Pickup branch is required",
            })}
            errors={errors?.from_branch}
            name={"from_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            disabled={!isActive}
            placeholder={"Search  Branch"}
            clearErrors={clearErrors}
          />
          <LocationComboboxInput
            url={APIS.LOCATION}
            queryKey={"city"}
            register={register("destination", {
              required: "destination is required",
            })}
            errors={errors?.destination}
            name={"destination"}
            label={"Destination"}
            props={{
              is_active: true,
              level: 3,
            }}
            setValue={setValue}
            getValues={getValues}
            disabled={!isActive}
            placeholder={"Search  Destination"}
            clearErrors={clearErrors}
          />
        </div>
        {isEdit ? <hr className={tw`my-4 border-gray-300`} /> : <></>}

        {isEdit ? (
          fields.map((item: any, index: any) => (
            <div key={index} className={tw` mt-2`}>
              <p className={tw`text-[#5E5757] font-bold text-xs`}>
                ITEMS {index + 1}
              </p>

              <div className={tw`grid grid-cols-6 gap-x-4  items-center -mt-4`}>
                <div className={tw`mt-2`}>
                  <TextField
                    label={"Product Description"}
                    register={register(`items.${index}.description`)}
                  />
                </div>

                <ProductTypeComboboxInput
                  url={APIS.PRODUCT_TYPE}
                  queryKey={"product-type"}
                  register={register(`items.${index}.product_type` as const, {
                    required: "Product Type is required",
                  })}
                  errors={errors?.items?.[index]?.product_type}
                  name={`items.${index}.product_type`}
                  label={"Product Type"}
                  setValue={setValue}
                  props={{ is_active: true }}
                  placeholder={"Search Product Type"}
                  getValues={getValues}
                  disabled={!isActive}
                  clearErrors={clearErrors}
                  value={getValues()["items"][index]["product_type"]}
                />
                <div className={tw`mt-2`}>
                  <NumberField
                    value={getValues(`items.${index}.piece`)}
                    register={register(`items.${index}.piece`)}
                    errors={errors?.items?.[index]?.piece}
                    label={"Pcs"}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    disabled={!isActive}
                  />
                </div>
                <div className={tw`mt-2`}>
                  <TextField
                    label={"Weight(Kg)"}
                    register={register(`items.${index}.weight` as const, {
                      required: "Weight is required",
                      valueAsNumber: true,
                      validate: (value) =>
                        !isNaN(value) || "Weight must be a number",
                    })}
                    disabled={!isActive}
                    errors={errors?.items?.[index]?.weight}
                  />
                </div>

                <div
                  className={tw`flex items-center justify-start gap-x-2 mt-[35px]`}
                >
                  <button
                    type="button"
                    onClick={() =>
                      append({
                        description: "",
                        product_type: "",
                        piece: 1,
                        weight: "",
                      })
                    }
                    className={tw`px-3  text-green-600 text-xl border border-green-400 rounded hover:bg-green-50`}
                    title="Add Item"
                  >
                    +
                  </button>

                  {fields.length > 1 && (
                    <button
                      type="button"
                      onClick={() => remove(index)}
                      className={tw`px-3 text-red-600 text-xl border border-red-400 rounded hover:bg-red-50`}
                      title="Remove Item"
                    >
                      -
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        <hr className={tw`my-4 border-gray-300`} />

        <TextField
          label={"Note"}
          register={register(`note`)}
          errors={errors?.note}
          disabled={!isActive}
        />
      </div>
    </>
  );
};

export default Form;
